import { fieldTypes, TABS } from "@icarius-utils/constants";

const NAME = "DIRECTORY_PAGE";

export const directoryEmployeeFields = [
  {
    name: "NRO INTERNO",
    type: fieldTypes.text,
    label: "internalNumber",
    tab: TABS.personal,
  },
  {
    name: "EMAIL",
    type: fieldTypes.email,
    label: "email",
    tab: TABS.personal,
  },
  {
    name: "CELULAR",
    type: fieldTypes.phone,
    label: "cellphone",
    tab: TABS.personal,
  },
  {
    name: "ESTADO CIVIL",
    type: fieldTypes.text,
    label: "civilState",
    tab: TABS.personal,
  },
  {
    name: "SEXO",
    type: fieldTypes.text,
    label: "sex",
    tab: TABS.personal,
  },
  {
    name: "NACIONALIDAD",
    type: fieldTypes.text,
    label: "nationality",
    tab: TABS.personal,
  },
  {
    name: "FECHA DE NACIMIENTO",
    type: fieldTypes.text,
    label: "bornDate",
    tab: TABS.personal,
  },
  {
    name: "LUGAR DE PAGO",
    type: fieldTypes.text,
    label: "paymentLocation",
    tab: TABS.location,
  },
  {
    name: "LUGAR DE TRABAJO",
    type: fieldTypes.text,
    label: "jobLocation",
    tab: TABS.location,
  },
  {
    name: "GERENCIA",
    type: fieldTypes.text,
    label: "management",
    tab: TABS.location,
  },
  {
    name: "DEPARTAMENTO",
    type: fieldTypes.text,
    label: "department",
    tab: TABS.location,
  },
  {
    name: "SECCION",
    type: fieldTypes.text,
    label: "section",
    tab: TABS.location,
  },
  {
    name: "TURNO",
    type: fieldTypes.text,
    label: "shift",
    tab: TABS.time,
  },
  {
    name: "HORARIO",
    type: fieldTypes.text,
    label: "scheduleProgrammed",
    tab: TABS.time,
  },
  {
    name: "INASISTENCIA",
    type: fieldTypes.text,
    label: "assistanceStatus",
    tab: TABS.time,
  },
];

export default NAME;
